import { useEffect, useState } from 'react';

/**
 * Debounce a fast-changing value (the M10 search inputs): the returned value trails `value`
 * by `delayMs`, so a React Query keyed on it fires once per pause, not per keystroke.
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
